import axios from "axios";
import { API_URL } from "@src/config/apiconfig";

const loginAction = async (username, password) => {
    try {
        const response = await axios.post(
            API_URL.LOGIN,
            { login: username, password },
            {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        );


        const { status, message, data } = response.data;

        if (!status) {
            return { success: false, message: message || "Login failed" };
        }


        localStorage.setItem("isAdminAuthenticated", "true");
        localStorage.setItem("adminUser", JSON.stringify(data));

        return { success: true, message, data };

    } catch (error) {


        return {
            success: false,
            message: error.response?.data?.message || "Network error. Please try again.",
        };
    }
};

export default loginAction;
